export const blue700 = '#2468e5'
export const blue20 = '#E7E7F2'
